export default __webpack_public_path__ + "static/media/complementary--when-snowy-or-rainy--g2.bf4655ce.png";